import { render } from "./ForeignTradeByProducts.vue?vue&type=template&id=7849b568&ts=true"
import script from "./ForeignTradeByProducts.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByProducts.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__